'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCellsMetadataCoordinates = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCellsMetadataCoordinates = exports.getCellsMetadataCoordinates = function getCellsMetadataCoordinates(metadataCoordinates, oneValueDimensions, layoutIds) {
  var oneValueDimsIds = R.pluck('id', oneValueDimensions);
  return R.reject(function (coordinates) {
    var columnIds = R.concat(layoutIds.header, oneValueDimsIds);
    if (R.isEmpty(R.omit(columnIds, coordinates))) {
      return true;
    }
    var rowsIds = [].concat((0, _toConsumableArray3.default)(layoutIds.sections), (0, _toConsumableArray3.default)(layoutIds.rows), (0, _toConsumableArray3.default)(oneValueDimsIds));
    return R.isEmpty(R.omit(rowsIds, coordinates));
  }, metadataCoordinates);
};